/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Coherent Labs AD. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import Keyboard from './lib_components/keyboard';
import IM from './utils/global-object';

IM.init();

export default Keyboard;
